export const state = {
    isLoading: false,
    isError: true,
    vehicleDetail:"",
};